// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__pQ3Vb","title":"card_title__2_nha","inActive":"card_inActive__3DNTG"};